var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tc-table',{attrs:{"dataList":_vm.list,"tbody":_vm.tableBody,"settings":{
    externalFilters: {
      show: false
    },
    filters: {
      status: {
        type: 'v-select',
        class: 'min-w-48',
        label: 'Status',
        clearable: false,
        options: {
          text: 'name',
          value: 'id',
          items: [{
            id: '',
            name: 'All'
          }, {
            id: 'Active',
            name: 'Active'
          }, {
            id: 'Locked',
            name: 'Locked'
          }]
        }
      },
      q: {
        type: 'input',
        class: 'min-w-48',
        label: 'Search'
      }
    }
  }},on:{"filter":_vm.filter}},[_c('template',{slot:"thead"},[_c('vs-th',[_vm._v("ID")]),_c('vs-th',[_vm._v("Name")]),_c('vs-th',[_vm._v("Company")]),_c('vs-th',[_vm._v("Email")]),_c('vs-th',[_vm._v("Mobile")]),_c('vs-th',[_vm._v("Last Login")]),_c('vs-th',[_vm._v("Last CheckIn")]),_c('vs-th',[_vm._v("Visits")]),_c('vs-th',[_vm._v("Hosts")]),_c('vs-th',[_vm._v("Locations")]),_c('vs-th',[_vm._v("Status")]),_c('vs-th',[_vm._v("Created")]),_c('vs-th')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }